import script from "./NoticableList.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticableList.vue?vue&type=script&setup=true&lang=js"

import "./NoticableList.vue?vue&type=style&index=0&id=7ac3e4ce&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ac3e4ce"]])

export default __exports__